import React from 'react';
import TopPanel from "./../toppanel.js";
import ChecklistEdit from "./checklistedit.js";
import CheckListView from "./checklistview.js";

module.exports = React.createClass({
    success: function(reply) {
        this.commandCounter--;
        if (this.commandCounter < 0)
            this.commandCounter = 0;
        if (!this.mountState)
            return;
        if (!this.commandCounter) { // don't update model is there're other commands in queue
            HC_SetDataAndSelectedItem(this, reply.data);
        }
    },
    successDocuments: function(reply) {
        if (!this.mountState)
            return;
        this.setState({documents: reply.data});
    },
    successUsers: function (reply) {
        this.state.allUsers = reply.data;
    },
    loadFromServer: function(id=null) {
        this.commandCounter++;
        HC_SendRequest("checklists", null, this.success, null);
        HC_SendRequest("documents", {empty: true}, this.successDocuments, null);
        HC_SendRequest("users", null, this.successUsers, null);
    },
    getInitialState: function() {
        this.commandCounter = 0;
        return {
            data: [],
            selectedId: null,
            documents: [],
            allUsers: [],
            mode: HC_CONST.CL_MODE_EDIT,
            goBackEnabled: false,
            noData: true
        }
    },
    componentWillMount: function() {
        this.mountState = true;
        HC_CheckLoginAndAcc(this, HC_AccAdmin);
    },
    componentWillUnmount() {
        this.mountState = true;
    },
    componentDidMount: function() {
        HC_RestoreNavPanel();
        HC_SelectNavItem("li-checklists");
        this.loadFromServer();
    },
    handleOnSelected: function(e, createNew=false) {
        if (this.state.mode === HC_CONST.CL_MODE_ORDER)
            return;
        this.goBack();
        if (HC_DeviceType() == HC_CONST.SCR_PHONE) {
            this.state.goBackEnabled=true;
            HC_SwitchRPanel();
        }
        this.setState({selectedId: e});
    },
    getItemCaption: function(o) {
        return o.name;
    },
    handleOnDelete: function() {
        var checklist = HC_CurrentItem(this);
        if (checklist)
            return HC_Confirm(HC_LANG.CHL_DELETE_CHL + ' "' + checklist.name + '"?', HC_LANG.CHL_DELETE, HC_LANG.DUE_CANCEL).then(function () {
                    this.commandCounter++;
                    this.state.data = [];
                    this.state.selectedId = null;
                    HC_SendRequest('delete_checklist', {id: parseInt(checklist.id)}, this.success);
                    HC_CloseModal();
                    this.goBack();
            }.bind(this));
    },
    handleOnDeleteRow: function(id) {
        var checklist = HC_CurrentItem(this);
        if (checklist) {
            var checklistItem = checklist.items.find(function(o) {return o.id == id;});

            if (this.state.mode == HC_CONST.CL_MODE_CREATE) {
                checklist.items.splice(checklist.items.indexOf(checklistItem), 1);
                this.setState({data: this.state.data});
                return;
            }

            if (checklistItem) {
                return HC_Confirm(HC_LANG.CHL_DELETE_ITEM + ' "' + checklistItem.item + ' - ' + checklistItem.action + '"?', HC_LANG.CHL_DELETE, HC_LANG.DUE_CANCEL).then((function (_this) {
                    return function() {
                        checklist.items.splice(checklist.items.indexOf(checklistItem), 1);
                        _this.setState({data: _this.state.data});
                        var data = {id: parseInt(checklist.id), deleted_items: [parseInt(id)]};
                        this.commandCounter++;
                        HC_SendRequest('edit_checklist', data, _this.success);
                    };
                })(this));
            }
        }
    },
    handleOnCreateRow: function(item, action) {
        let checklist = HC_CurrentItem(this);
        if (checklist) {
            let isNew = this.state.mode == HC_CONST.CL_MODE_CREATE;
            let id = (checklist.items.length == 0) ? 1 : parseInt(checklist.items[checklist.items.length-1].id) + 1;
            checklist.items.push({id: id, item: item, action: action, temp: !isNew});

            this.setState({data: this.state.data});

            var data = {id: parseInt(checklist.id), items:[{item:item, action:action}]};
            if (!isNew) {
                this.commandCounter++;
                HC_SendRequest('edit_checklist', data, this.success);
            }
        }
    },

    handleOnSaveChanges: function(changes) {
        var checklist = HC_CurrentItem(this);
        if (this.state.mode == HC_CONST.CL_MODE_CREATE) {
            if (changes.name !== undefined)
                checklist.name = changes.name;
            if (changes.fill_in)
                checklist.fill_in = changes.fill_in;
            if (changes.errors_allowed)
                checklist.errors_allowed = changes.errors_allowed;
            if (changes.linked_document)
                checklist.linked_document = changes.linked_document;
            if (changes.manual_state)
                checklist.manual_state = changes.manual_state;
            if (changes.linked_users) {
                if (changes.linked_users[0].user_id === -1) {
                    // check all users
                    checklist.linked_users = this.state.allUsers.map(function (u) {
                        return ({"user_id": u.id, "checked": changes.linked_users[0].checked})
                    });
                }
                else {
                    let user = checklist.linked_users.find(function(u) { return u.user_id === changes.linked_users[0].user_id});
                    if (user == undefined)
                        checklist.linked_users.push(changes.linked_users[0]);
                    else
                        user.checked = changes.linked_users[0].checked;
                }
            }
            if (changes.checklist_type != undefined)
                checklist.checklist_type = changes.checklist_type;
            if (changes.duration)
                checklist.duration = changes.duration;
            if (changes.range != undefined) {
                checklist.range = changes.range;
            }
            if (changes.startup_time)
                checklist.startup_time = changes.startup_time;
            if (changes.onceTime)
                checklist.range = checklist.duration * 60;
            if (changes.decrease_temp) {
                checklist.decrease_temp = true;
            }
            this.setState({data: this.state.data});
        } else {
            if (changes.onceTime) {
                changes.range = (changes.duration ? changes.duration : checklist.duration) * 60;
            }
            if (!HC_Validate())
                return false;
            this.commandCounter++;
            HC_SendRequest('edit_checklist', changes, this.success);
        }
    },
    handleCreateNew: function() {
        if (this.state.mode == HC_CONST.CL_MODE_CREATE)
            return;

        var newCheckList = {
            id: -1,
            name: '',
            fill_in: "every|1|d",
            errors_allowed: "0|d",
            linked_document: -1,
            linked_users: [],
            items: [],
            manual_state: 0
        };
        var state = {};
        this.state.data.unshift(newCheckList);
        state.selectedId = -1;
        state.mode = HC_CONST.CL_MODE_CREATE;
        state.goBackEnabled = true;
        this.setState(state);
        if (HC_DeviceType() == HC_CONST.SCR_PHONE)
            HC_SwitchRPanel();
    },
    handleSetOrder: function() {
        this.setState({mode: HC_CONST.CL_MODE_ORDER, selectedId: null});
    },
    handleFinishSetOrder: function() {
        this.setState({mode: HC_CONST.CL_MODE_EDIT});
    },
    setOrderUp: function(checklistId) {
        var a = this.state.data;
        var temp;
        for (var i=0; i<a.length; ++i) {
            if (a[i].id == checklistId) {
                if (i === 0)
                    return; // first element can't be moved up
                temp = a[i-1];
                a[i-1] = a[i];
                a[i] = temp;
                this.setState({data: a, selectedId: parseInt(checklistId)});
                break;
            }
        }
        this.commandCounter++;
        HC_SendRequest('set_checklist_order', {checklist_id: parseInt(checklistId), up: 1}, this.success);
    },
    setOrderDown: function(checklistId) {
        var a = this.state.data;
        var temp;
        for (var i=0; i<a.length; ++i) {
            if (a[i].id == checklistId) {
                if (i === a.length-1)
                    return; // last element can't be moved down
                temp = a[i+1];
                a[i+1] = a[i];
                a[i] = temp;
                this.setState({data: a, selectedId: parseInt(checklistId)});
                break;
            }
        }
        this.commandCounter++;
        HC_SendRequest('set_checklist_order', {checklist_id: parseInt(checklistId), up: 0}, this.success);
    },
    resetCreate: function() {
        if (this.state.mode != HC_CONST.CL_MODE_CREATE)
            return;
        if (this.state.data.length > 0 && this.state.data[0].id == -1)
            this.state.data.shift();  // remove fake New User item
        this.state.selectedId = this.state.data.length > 0 ? this.state.data[0].id : null;
        HC_RestoreRPanel();
        this.setState({mode: HC_CONST.CL_MODE_EDIT});
    },
    handleSaveNew: function() {
        if (!HC_Validate())
            return false;

        let newChecklist = HC_CurrentItem(this);
        if (newChecklist.items.length == 0) {
            $('#must-have-item-error').css('display', 'block').addClass('hc-f5').css('color', '#d0021b').text(HC_LANG.CHL_NEED_ITEM);
            return;
        }
        else
            $('#must-have-item-error').css('display', 'none').removeClass('hc-f5');

        if (!HC_Validate())
            return;

        this.commandCounter++;
        // HardCode!!!
        newChecklist.linked_users = newChecklist.linked_users.filter(function (us) {
            return us.checked == true;
        }).map( function( u ) { return u.user_id; } );

        HC_SendRequest('add_checklist', newChecklist, this.success);
        this.state.selectedId = null;
        this.state.data = [];
        this.resetCreate();
    },
    handleLaunch: function(clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        var id = clickEvent.target.getAttribute('data-key');
        var checklist = HC_GetItemById(this.state.data, id);
        if (!checklist || checklist.manual_state != 1)
            return;

        checklist.manual_state = 2;
        window.HC_DueCount += 1;
        this.commandCounter++;
        HC_SendRequest('launch_manual_checklist', {id: checklist.id, manual_state: 2}, this.success);
        this.setState({data: this.state.data});
    },
    handleCancelLaunch: function(clickEvent) {
        clickEvent.preventDefault();
        clickEvent.stopPropagation();
        var id = clickEvent.target.getAttribute('data-key');
        var checklist = HC_GetItemById(this.state.data, id);
        if (!checklist || checklist.manual_state != 2)
            return;

        checklist.manual_state = 1;
        window.HC_DueCount -= 1;
        this.commandCounter++;
        HC_SendRequest('edit_checklist', {id: checklist.id, manual_state: 1}, this.success);
        this.setState({data: this.state.data});
    },
    goBack: function() {
        switch (this.state.mode) {
            case HC_CONST.CL_MODE_CREATE:
                this.resetCreate();
                this.setState({mode: HC_CONST.CL_MODE_EDIT, goBackEnabled: false});
                break;
            case HC_CONST.CL_MODE_EDIT:
                HC_RestoreRPanel();
                break;
        }
    },
    render: function() {
        if (this.state.mode != HC_CONST.CL_MODE_CREATE)
            this.resetCreate();

        var ricon, riconClick, rbutton;
        var licon = "fa-bars";
        var liconClick = HC_ToggleNavPanel;

        var devType = HC_DeviceType();

        if (devType === HC_CONST.SCR_DESCKTOP) {
            ricon = "fa-plus-circle";
            riconClick = this.handleCreateNew;
        } else {
            rbutton = {
                items: [
                    {
                        name: HC_LANG.CHL_CREATE_CHL,
                        action: this.handleCreateNew,
                        icon: "fa-plus-circle"
                    },
                    {
                        name: HC_LANG.DOC_SET_ORDER,
                        action: this.handleSetOrder,
                        icon: "fa-sort-amount-desc "
                    }]
            };
        }

        var content = (<ChecklistEdit data={this.state.data} documents={this.state.documents} allUsers={this.state.allUsers}
                                  selectedId={this.state.selectedId} onDelete={this.handleOnDelete}
                                  onCreateRow={this.handleOnCreateRow} onDeleteRow={this.handleOnDeleteRow}
                                  onSaveChanges={this.handleOnSaveChanges}
                                  onGoBack={this.goBack} goBackEnabled={this.state.goBackEnabled}
                                  onSaveNewChecklist={this.handleSaveNew}
                                  successAssignUser={this.success}/>);

        if (this.state.mode === HC_CONST.CL_MODE_CREATE)
            licon = liconClick = rbutton = null;

        if (this.state.mode === HC_CONST.CL_MODE_ORDER) {
            rbutton = null;
            ricon = "fa-check-circle";
            riconClick = this.handleFinishSetOrder;
        }

        var launch = false;
        if (this.state.mode === HC_CONST.CL_MODE_EDIT)
            launch = true;

        return (
            <div id="panel-checklists" style={{height:"100%"}}>
                <div className="hc-list-panel hc-br">
                    <TopPanel text={HC_LANG.CHL_CAPTION} licon={licon} onLiconClick={liconClick} ricon={ricon} onRiconClick={riconClick} rbutton={rbutton}/>
                    <div>
                        <CheckListView data={this.state.data} getCaption={this.getItemCaption} getText={HC_GetChecklistText} selectedId={this.state.selectedId} onSelect={this.handleOnSelected}
                                       showSearch={true} order={this.state.mode === HC_CONST.CL_MODE_ORDER || devType === HC_CONST.SCR_DESCKTOP} onSetOrderDown={this.setOrderDown} onSetOrderUp={this.setOrderUp}
                                       launch={launch} onLaunch={this.handleLaunch} onCancelLaunch={this.handleCancelLaunch}/>
                    </div>
                </div>
                <div className="hc-content-panel">
                    {content}
                </div>
            </div>
        );
    }
});



// WEBPACK FOOTER //
// ./checklists/checklists.js